export default __webpack_public_path__ + "static/media/location-contactUs.f660a0a5.svg";